<!-- Begin page -->
<div id="layout-wrapper">
    <app-topbar></app-topbar>
     <app-horizontal-topbar></app-horizontal-topbar>
     
     <div class="main-content">
 
         <div class="page-content">
             <div class="container-simbirgi">
               <div class="mt-4 mt-xl-0"></div>
               <!-- content -->
               <router-outlet></router-outlet>
             </div>
              <!-- footer -->
              <app-footer></app-footer>
         </div>
     </div>
 </div>
 
 <app-rightsidebar (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar>
